<script>
import { mapState } from 'vuex';

export default {
  computed: mapState({
    Permissions: state => state.permissions.permissions,
  }),
  methods: {
    $can(permissionName) {
      return this.Permissions.indexOf(permissionName) !== -1;
    },
    $hasRole(roles) {
      let hasRole = false;
      for(let role of roles) {
        if(this.$auth.user().roles) {
          if(this.$auth.user().roles[0].name == role) {
            hasRole = true;
          }
        }
      }
      return hasRole;
    }
  }
}
</script>